var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 40.7C19.3 40.7 15.3667 39.075 12.1 35.825C8.83333 32.575 7.2 28.6333 7.2 24C7.2 19.4 8.83333 15.4583 12.1 12.175C15.3667 8.89167 19.3 7.25 23.9 7.25C26.8667 7.25 29.4667 7.85 31.7 9.05C33.9333 10.25 35.8667 11.9 37.5 14V7.25H40.8V21H27.05V17.7H35.35C34.05 15.7667 32.4583 14.2083 30.575 13.025C28.6917 11.8417 26.4667 11.25 23.9 11.25C20.3333 11.25 17.3167 12.4833 14.85 14.95C12.3833 17.4167 11.15 20.4333 11.15 24C11.15 27.5667 12.3833 30.5833 14.85 33.05C17.3167 35.5167 20.3333 36.75 23.9 36.75C26.5667 36.75 29.0333 35.9833 31.3 34.45C33.5667 32.9167 35.15 30.8833 36.05 28.35H40.15C39.15 32.05 37.15 35.0333 34.15 37.3C31.15 39.5667 27.7333 40.7 23.9 40.7V40.7Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.84943a72eff25f2fe8adca3ed507f29a.svg";
export { ForwardRef as ReactComponent };